import Layout from '@/views/layout/Layout'

const cmsUniversityInfoRoutes = {
  path: '/cms/university',
  component: Layout,
  redirect: '/cms/university/info',
  name: 'cms.university',
  meta: { title: '院校', icon: 'cms' },
  children: [
    {
      path: 'info',
      name: 'cms.university.info',
      component: () => import('@/views/cms/university/info'),
      meta: { title: '院校信息', icon: 'ums-admin' }
    },
    {
      path: 'summary',
      name: 'cms.university.summary',
      component: () => import('@/views/cms/university/summary'),
      meta: { title: '院校概况', icon: 'ums-admin' }
    },
    {
      path: 'major',
      name: 'cms.university.major',
      component: () => import('@/views/cms/university/major'),
      meta: { title: '院校建设', icon: 'ums-admin' }
    },
    {
      path: 'teacher',
      name: 'cms.university.teacher.list',
      component: () => import('@/views/cms/teacher/list'),
      meta: { title: '师资力量', icon: 'ums-admin' }
    },
    {
      path: 'teacher/create',
      name: 'cms.university.teacher.create',
      hidden: true,
      component: () => import('@/views/cms/teacher/create'),
      meta: { title: '添加师资', icon: 'ums-admin' }
    },
    {
      path: 'teacher/:id/edit',
      name: 'cms.university.teacher.edit',
      hidden: true,
      component: () => import('@/views/cms/teacher/edit'),
      meta: { title: '编辑师资', icon: 'ums-admin' }
    }
  ]
}

export default cmsUniversityInfoRoutes



// WEBPACK FOOTER //
// ./src/router/module/cmsUniversityInfoRoutes.js